import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PageviewTracker() {
  const location = useLocation();

  useEffect(() => {
    fetch(`${API}/analytics/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: location.pathname })
    }).catch(() => {});
  }, [location.pathname]);

  return null;
}
